import { WidgetsProvider } from "~/provider";
import { BaseWidget } from "~/services/modules";
import { MissingTargetError } from "~/util/errors";
import { renderScoped } from "~/util/widgets";
import { DatesProvider } from "../../providers/dates";
import { DatesRoot } from "./Root";

interface Config {
	target: HTMLElement;
	[key: string]: any;
}

export class DatesWidget extends BaseWidget {

	public override onMount({ target, theme, locale }: Config) {

		if (!target) {
			throw new MissingTargetError();
		}

		renderScoped(() => (
			<WidgetsProvider settings={{ theme, locale }}>
				<DatesProvider>
					<DatesRoot />
				</DatesProvider>
			</WidgetsProvider>
		), target);
	}
}